import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {Form, FormikProps} from "formik";
import {
  ADVANCED_SEARCH_SCOPE_CONFIGURATION_FIELDS as SCOPE_CONFIGURATION_FIELDS,
  getSearchFormValuesByState,
} from "../../../../helpers/configurationHelper";
import DateFields from "../../../shared/fields/DateFields";
import {AdvancedSearchConfigurationsType} from "../../../../types/configurations";
import {ShapeType} from "../../../../types/shape";
import {ProductImageStacType} from "../../../../types/product";
import {
    resetSearchAction,
    resetSearchFiltersSelectedAction,
} from "../../../../state/application/actions";
import {AppParametersType} from "../../../../types/app";
import SearchButtons from "../../../shared/buttons/SearchButtons";
import DynamicSearchFieldsList from "../../../shared/dynamic-form/DynamicSearchFieldsList";
import InvalidateField from "../../../shared/fields/InvalidateField";
import translations from "../../../../translations";

interface PropsType {
    mainInputConfigurations: any;
    configurations: AdvancedSearchConfigurationsType;
    lastShape: ShapeType;
    selectedProducts: ProductImageStacType[];
    loadingInitialData: boolean;
    formProps: FormikProps<any>;
    resetSearchFiltersSelectedActionHandler: any;
    resetProductionFiltersSelectedActionHandler: any;
    appParameters: AppParametersType;
    language: string;
    updateFormDataPayloadActionHandler: any;
    formData: any;
    setSearchProductIdsHandler: any;
    setSearchMode: any;
    searchResults: any;
    isSearchingResults: boolean;
    searchFormValues: any;
    searchError: any;
    resetSearchActionHandler: any;
}

const InvalidationForm = (props: PropsType) => {
  const {
    mainInputConfigurations,
    configurations,
    lastShape,
    selectedProducts,
    formProps: originFormProps,
    resetSearchFiltersSelectedActionHandler,
    appParameters,
    language,
    searchResults,
    isSearchingResults,
    searchFormValues,
    searchError,
    resetSearchActionHandler
  } = props;

  const [invalidationResult, setInvalidationResult] = useState("");

  useEffect(() => {
    let invalidationResultText = "";
    if (isSearchingResults) {
      invalidationResultText += "Searching...";
    } else if (searchError) {
      invalidationResultText += `<p>${searchError}</p>`;
    } else if (searchResults) {
      invalidationResultText += `<p>${translations("invalidateSearchResultsText", language).replace('${scenes}', searchResults.items.length)}</p>`;
      invalidationResultText += `<p>${translations(searchFormValues.invalidate_mode ? "invalidateSearchResultsProceedText" : "validateSearchResultsProceedText", language)}</p>`;
    }
    setInvalidationResult(invalidationResultText);
  }, [isSearchingResults, searchResults, searchError]);

  const formProps = {
    ...originFormProps,
    resetForm: () => {
      originFormProps.resetForm();
      resetSearchFiltersSelectedActionHandler();
      resetSearchActionHandler();
    },
  };

  return (
    <Form className="filters-form">
      <div className="inner-content">
        <div className="p-3">

          <DateFields
            configurations={configurations}
            mainInputConfigurations={mainInputConfigurations}
            scopeConfigurationFields={SCOPE_CONFIGURATION_FIELDS}
            selectedArea={lastShape}
            selectedProducts={selectedProducts}
            formProps={formProps}
            appParameters={appParameters}
            onTop
          />

          <InvalidateField
            formProps={formProps}
            appParameters={appParameters}
            language={language}
          />

          <DynamicSearchFieldsList
            key="invalidation-advanced-filters-all-missions"
            configurations={configurations}
            scopeConfigurationFields={SCOPE_CONFIGURATION_FIELDS}
            selectedArea={lastShape}
            selectedProducts={selectedProducts}
            formProps={formProps}
            appParameters={appParameters}
          />

          <div className="row mx-0 mb-3 border-top">
            {invalidationResult !== "" && (
              <div className="invalidation-results-box" dangerouslySetInnerHTML={{__html: invalidationResult}} />
            )}
          </div>

        </div>
      </div>
      <SearchButtons
        mainInputConfigurations={mainInputConfigurations}
        configurations={configurations}
        scopeConfigurationFields={SCOPE_CONFIGURATION_FIELDS}
        selectedArea={lastShape}
        formProps={formProps}
        selectedProducts={selectedProducts}
        appParameters={appParameters}
      />
    </Form>
  );
};

const mapStateToProps = (state) => ({
  appParameters: state.application.appParameters,
  language: state.application.appParameters.language,
  searchResults: state.product.searchResults,
  isSearchingResults: state.product.isSearchingResults,
  searchError: state.product.error,
  searchFormValues: getSearchFormValuesByState(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  resetSearchFiltersSelectedActionHandler: () => dispatch(resetSearchFiltersSelectedAction()),
  resetSearchActionHandler: () => dispatch(resetSearchAction())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvalidationForm);
